import type { models } from '../models';
import { Alert } from './alert';
import { Modal } from './modal';
import { PopUpModal } from './pop-up';
import { ToastDownModal } from './toast-down';
import { ToastUpModal } from './toast-up';

export class ModalsManager {
  private _modals: (Modal | null)[] = [];

  /**
   * open modal - use or remove already created modals
   */
  public openModal(rewardMessage: models.RewardMessage) {
    rewardMessage.RewardButtons?.sort(
      (a, b) => (a.Order ?? 0) - (b.Order ?? 0)
    );
    let modalType;
    let modalOpened: boolean = false;
    switch (rewardMessage.Variant) {
      case 1:
        modalType = PopUpModal;
        break;
      case 2:
        modalType = ToastUpModal;
        break;
      case 3:
        modalType = ToastDownModal;
        break;
      case 5:
        modalType = Alert;
        break;
    }

    if (!!modalType) {
      this._modals?.forEach(modal => {
        if (modal instanceof modalType && !modal?.isOpened()) {
          if (!modalOpened) {
            modal?.openModal(rewardMessage);
            modalOpened = true;
          } else {
            modal = null;
          }
        }
      });

      if (!modalOpened) {
        this._modals.push(new modalType(rewardMessage));
      }
    }
  }
}
